/**
 * Extract asset ID (filename) from URL
 * Compatible with both local (Rails Active Storage disk) and S3 URLs
 */
export function extractAssetId(url: string): string | undefined {
  if (!url) return undefined;

  // Check if it's an S3 URL
  if (url.includes('s3.amazonaws.com')) {
    try {
      const urlObj = new URL(url);
      const contentDisposition = urlObj.searchParams.get('response-content-disposition');
      if (contentDisposition) {
        // Extract filename from response-content-disposition parameter
        // Format: attachment; filename="pink_pig_prompt-sing"; filename*=UTF-8''pink_pig_prompt-sing
        const filenameMatch = contentDisposition.match(/filename[^;=]*=([^;]*)/);
        if (filenameMatch && filenameMatch[1]) {
          // Remove quotes and decode URI component
          let filename = filenameMatch[1].trim().replace(/^["']|["']$/g, '');
          filename = decodeURIComponent(filename);
          return filename;
        }
      }
    } catch (e) {
      console.warn('Failed to parse S3 URL:', url, e);
      // Fallback to path-based extraction
    }
  }

  // For local URLs (Rails Active Storage disk), extract filename from path
  // Format: http://api.localhost:3000/rails/active_storage/disk/eyJ.../filename.mp4
  const filename = url.split('/').pop()?.split('?')[0];
  return filename;
}

